import {AfterViewInit, Component, OnDestroy, OnInit} from '@angular/core';
import * as $ from 'jquery';
import {EmisoresListComponent} from './emisores-list.component';
import * as myGlobals from './../global';
import {NgForm} from "@angular/forms";
import { errorMessageFromAjax } from '../services/ajax-error';

@Component({
  selector: 'pm-add-emisor',
  templateUrl: './add-emisor.component.html',
  styleUrls: ['./add-emisor.component.sass']
})
export class AddEmisorComponent implements OnInit, OnDestroy, AfterViewInit {
  public pageTitle = 'Nuevo Emisor';

  formData = {
    id: 0,
    name: '',
  };

  constructor(private parent: EmisoresListComponent) {
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    $('a[rel=emisores]').addClass('selected');
  }

  cancelEmisor(): void {
    this.parent.showEmisores = true;
    this.parent.showAddEmisor = false;
  }

  addEmisor(form: NgForm): void {

    console.log('addEmisor: form: ', form);
    if (form.invalid) {
      Object.values(form.controls).forEach(control => {
        control.markAsTouched();
      });
      return;
    }

    const parentRef = this.parent;
    const formData = {
      id: 0,
      issuer: form.value.name /* $('input[name=name]').val() /* ,
      status: $('#myselect option:selected').val() */
    };
    $.ajax({
      url: myGlobals.baseApi + '/webadmin/v1/card-issuer',
      dataType: 'json',
      headers: {
        sessionToken: localStorage.getItem('sessionToken')
      },
      contentType: 'application/json; charset=utf-8',
      type: 'POST',
      data: JSON.stringify(formData)
    }).done(function (response) {
      //
      parentRef.showEmisores = true;
      parentRef.showAddEmisor = false;
      console.log('Add sucess!!');
    }).fail(function(jqXHR) {
      alert('No se pudo dar de alta el emisor: ' + errorMessageFromAjax(jqXHR));
    });

  }

  ngOnDestroy() {
    $('a[rel=emisores]').removeClass('selected');
  }
}
